// Centralized lead submission helper for R0AM by Wadiah Mutual.
//
// DEMO MODE (default): validates upstream, logs the CRM-ready JSON payload to the
// console, and resolves successfully WITHOUT sending any network request.
//
// LIVE MODE: when SITE.apiBase is set AND demo mode is off, the same payload is
// POSTed to the mutualautomation endpoint. No API keys or secrets are ever sent
// from the browser — authentication and HubSpot sync happen server-side inside
// mutualautomation. This keeps the static Hostinger build safe to deploy.
import { SITE, ENDPOINTS } from "../data/config";

export function isLive() {
  return !SITE.demoForms && !!SITE.apiBase;
}

// endpointKey: a key of ENDPOINTS (e.g. "leads", "quotes", "chatbotQuoteIntake").
// payload: plain JSON object. options.label: console log prefix.
export async function submitLead(endpointKey, payload, { label = "[R0AM demo]" } = {}) {
  const path = ENDPOINTS[endpointKey] || endpointKey;
  const url = SITE.apiBase + path;

  if (!isLive()) {
    // Demo mode — log only, never send.
    // eslint-disable-next-line no-console
    console.log(`${label} POST`, url, payload);
    return { ok: true, demo: true };
  }

  // Live mode — POST to mutualautomation (no auth header by design).
  try {
    const res = await fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });
    return { ok: res.ok, demo: false, status: res.status };
  } catch (err) {
    return { ok: false, demo: false, error: String(err) };
  }
}
